/**
 * The "Plans" button — opens the sandbox's own Billing & Subscription → Plans tab.
 *
 * 🔴 AN IN-APP `<Link>`, NOT AN EXTERNAL ANCHOR. This used to point at the
 * marketing site's pricing page (`target="_blank"`) because a sandbox visitor
 * has no real account. The sandbox now seeds a full fake subscription + plan
 * catalog (see `sandboxLinks.ts` — `PLANS_URL`), so the real in-app Plans tab
 * renders correctly. React Router navigates client-side, so this does NOT
 * reload the page or destroy the IndexedDB-seeded session the way leaving the
 * origin would.
 */

import React from 'react';
import { Link } from 'react-router-dom';

import { PLANS_URL } from '../sandboxLinks';

export function PricingButton() {
  return (
    <Link
      className="tour-guide-launcher tour-guide-launcher--plans"
      to={PLANS_URL}
      data-testid="pricing-button"
      /* No `title` — the label doubles as the tooltip; see `TourLauncher`. */
      aria-label="See plans and pricing"
    >
      {/* Inlined so the module carries no icon-library dependency. */}
      <svg
        className="tour-guide-launcher__icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V4a2 2 0 0 1 2-2h8l8.59 8.59a2 2 0 0 1 0 2.82Z" />
        <line x1="7" y1="7" x2="7.01" y2="7" />
      </svg>
      <span className="tour-guide-launcher__label">Plans</span>
    </Link>
  );
}
